import { pack, record } from 'rrweb';

// 每分钟修剪一次录制数据，防止内存占用过大
const LOOP_CLEAR_TIME = 60 * 1000;
// 录制切块，每xx聚集为一组
const RECORD_PIECE_TIME = 20 * 1000;
class RRWebRecorder {
  static instance;
  eventsMatrix;
  stopFn;
  onChange;

  constructor() {
    this.eventsMatrix = [[]];
  }

  static getInstance() {
    if (!RRWebRecorder.instance) {
      RRWebRecorder.instance = new RRWebRecorder();
    }
    return RRWebRecorder.instance;
  }

  // 定时清除，只保留最新的两次录制数据
  loopClear() {
    setInterval(() => {
      const len = this.eventsMatrix.length;
      if (len > 2) {
        this.eventsMatrix = this.eventsMatrix.slice(len - 2, len);
      }
    }, LOOP_CLEAR_TIME);
  }

  getResentData() {
    const len = this.eventsMatrix.length;
    const events =
      len > 1
        ? this.eventsMatrix[len - 2].concat(this.eventsMatrix[len - 1])
        : this.eventsMatrix[len - 1];
    return events;
  }

  getAllData() {
    return this.eventsMatrix.flat();
  }

  start() {
    this.clearRecords();
    this.stopFn = record({
      emit: this.emitEvent.bind(this),
      checkoutEveryNms: RECORD_PIECE_TIME,
      sampling: {
        // @ts-ignore
        packFn: pack,
        scroll: 150,
        media: 800,
        input: 'last',
      },
    });
  }

  stop() {
    if (this.stopFn) this.stopFn();
  }

  emitEvent(event, isCheckout) {
    if (isCheckout) {
      this.eventsMatrix.push([]);
    }
    const lastEvents = this.eventsMatrix[this.eventsMatrix.length - 1];
    lastEvents.push(event);
    this.onChange?.();
  }

  clearRecords() {
    this.eventsMatrix = [[]];
  }
}

// 使用示例
export default RRWebRecorder;
